/**
 * Created by coolguy on 2017/4/15.
 */

import LoginAction from './LoginAction';
import CommonAction from './CommonAction';
import PermissionAction from './PermissionAction';
import UserAction from './UserAction';
import OrderAction from'./OrderAction';
import ProductAction from './ProductAction';
import RemitAction from './RemitAction';
import OppoAction from './OppoAction';
import ClueAction from './ClueAction';
import ImageAction from './ImageAction';
import ConsumerAction from './ConsumerAction';
import GalleryAction from './GalleryAction';
import BillAction from './BillAction';
import AgreementAction from './AgreementAction';
import AreaAction from './AreaAction';
import ContactAction from './ContactAction';
import DepartmentAction from './DepartmentAction';
import SceneAction from './SceneAction';
import QrcodeAction from './QrcodeAction';
import CommentAction from './CommentAction';
import ProxyAction from './ProxyAction';
import RedpackageAction from './RedpackageAction';
import AllocationAction from './AllocationAction';
import RateAction from './RateAction';
import Ajax from '../util/ajax.js';
import CheckAction from "./CheckAction";
import IMAction from './IMAction';
import ImageMessageAction from './ImageMessageAction';
import ToolAction from './ToolAction';
import CommentV2Action from './CommentV2Action';
import QualityAction from './QualityAction.js';

const {
    ajax
} = Ajax;

export default {
    ...CommentV2Action,
    ...SceneAction,
    ...LoginAction,
    ...CommonAction,
    ...PermissionAction,
    ...UserAction,
    ...BillAction,
    ...AgreementAction,
    ...OrderAction,
    ...ProductAction,
    ...RemitAction,
    ...OppoAction,
    ...ClueAction,
    ...ImageAction,
    ...ConsumerAction,
    ...GalleryAction,
    ...AreaAction,
    ...ContactAction,
    ...DepartmentAction,
    ...QrcodeAction,
    ...CommentAction,
    ...ProxyAction,
    ...RedpackageAction,
    ...CheckAction,
    ...AllocationAction,
    ...RateAction,
    ...IMAction,
    ...ImageMessageAction,
    ...ToolAction,
    ...QualityAction,
    log:(body)=>{
        ajax({
            method:'post',
            url:'/api/util/log',
            data:body
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/AjaxAction.js